import { useCallback, useEffect, useRef, useState, } from "react";
import { Modal, Pressable, StyleSheet, View, useWindowDimensions, } from "react-native";
import { useCustomTheme } from "../hooks/useCustomTheme";
export const ThemedDropdown = ({ open, anchorRef, onClose, children, minWidth = 460, margin = 8, maxContentHeight = 410, containerStyle, testIDBackdrop, accessibilityLabelClose = "Close", yOffset = 0, }) => {
    const { colors } = useCustomTheme();
    const { width: screenWidth, height: screenHeight } = useWindowDimensions();
    const contentRef = useRef(null);
    const [pos, setPos] = useState(null);
    const updatePlacement = useCallback(() => {
        const applyPlacement = (contentHeight) => {
            anchorRef.current?.measureInWindow?.((x, y, w, h) => {
                const effectiveContentHeight = contentHeight > 0 ? contentHeight : maxContentHeight;
                const desiredWidth = Math.min(Math.max(w, minWidth), screenWidth - margin * 2);
                const left = Math.max(margin, Math.min(x, screenWidth - desiredWidth - margin));
                const belowTop = y + h + margin + yOffset;
                const aboveTop = Math.max(margin, y - effectiveContentHeight - margin);
                const top = belowTop + effectiveContentHeight > screenHeight
                    ? aboveTop
                    : belowTop;
                setPos((currentPos) => {
                    if (currentPos &&
                        currentPos.top === top &&
                        currentPos.left === left &&
                        currentPos.width === desiredWidth) {
                        return currentPos;
                    }
                    return { top, left, width: desiredWidth };
                });
            });
        };
        if (contentRef.current?.measureInWindow) {
            contentRef.current.measureInWindow((_x, _y, _w, measuredHeight) => {
                applyPlacement(measuredHeight);
            });
            return;
        }
        applyPlacement(maxContentHeight);
    }, [
        anchorRef,
        maxContentHeight,
        margin,
        minWidth,
        screenHeight,
        screenWidth,
        yOffset,
    ]);
    useEffect(() => {
        if (!open)
            return;
        const id = requestAnimationFrame(updatePlacement);
        return () => cancelAnimationFrame(id);
    }, [open, updatePlacement, screenWidth, screenHeight]);
    return open ? (<Modal visible={open} transparent animationType="fade" onRequestClose={onClose} statusBarTranslucent presentationStyle="overFullScreen" onShow={updatePlacement}>
      <View style={styles.container}>
        <Pressable accessibilityRole="button" accessibilityLabel={accessibilityLabelClose} onPress={onClose} style={styles.backdrop} testID={testIDBackdrop}/>
        <View ref={contentRef} onLayout={open ? updatePlacement : undefined} style={[
            styles.dropdown,
            {
                borderColor: colors.muted,
                backgroundColor: colors.background,
            },
            pos
                ? {
                    top: pos.top,
                    left: pos.left,
                    width: pos.width,
                }
                : styles.dropdownStatic,
            containerStyle,
        ]}>
          {children}
        </View>
      </View>
    </Modal>) : null;
};
const styles = StyleSheet.create({
    backdrop: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 50,
    },
    dropdown: {
        borderRadius: 24,
        borderWidth: 1,
        padding: 16,
        zIndex: 100,
        elevation: 8, // Android
        position: "absolute",
    },
    container: {
        flex: 1,
        pointerEvents: "box-none",
    },
    dropdownStatic: {
        top: 100,
        left: 16,
        right: 16,
    },
});
//# sourceMappingURL=ThemedDropdown.js.map